export const PROJECT_DESCRIPTION_MIN_LENGTH = 10;
export const PROJECT_DESCRIPTION_MAX_LENGTH = 500;

export const PROJECT_DESCRIPTION_FORM_RULES = [
  { required: true, message: 'Please enter a project description' },
  { whitespace: true, message: 'Description cannot be only spaces' },
  {
    min: PROJECT_DESCRIPTION_MIN_LENGTH,
    message: `Description must be at least ${PROJECT_DESCRIPTION_MIN_LENGTH} characters`,
  },
  {
    max: PROJECT_DESCRIPTION_MAX_LENGTH,
    message: `Description cannot exceed ${PROJECT_DESCRIPTION_MAX_LENGTH} characters`,
  },
];
